(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/product-page-onboarding/assets/javascripts/intersection-observer.js') >= 0) return;  svs.modules.push('/templates/product-page-onboarding/assets/javascripts/intersection-observer.js');
"use strict";


const updateHintWithChanges = svs.templates.productPageOnboarding.hintItem.updateHintWithChanges;
const _svs$templates$produc = svs.templates.productPageOnboarding.onboardingInfo,
  getHintsFromClassname = _svs$templates$produc.getHintsFromClassname,
  getHintsFromId = _svs$templates$produc.getHintsFromId;

const intersectionObserverOpt = {
  root: null,
  rootMargin: '0px',
  threshold: 1.0,
  trackVisibility: true,
  delay: 200
};
const intersectionObserverCallback = entries => {
  entries.forEach(entry => {
    const tooltipTargetEl = entry.target;
    const id = tooltipTargetEl.id,
      classList = tooltipTargetEl.classList;
    let hints;
    if (id && id.length > 0) {
      hints = getHintsFromId(id);
    }
    if (!hints && classList && classList.length > 0) {
      classList.forEach(c => {
        hints = hints || getHintsFromClassname(c);
      });
    }
    if (hints) {
      hints.forEach(hint => {
        updateHintWithChanges(hint, {
          isVisible: entry.isVisible || entry.isIntersecting
        });
      });
    }
  });
};
const intersectionObserver = new IntersectionObserver(intersectionObserverCallback, intersectionObserverOpt);
const addIntersectionObserver = el => {
  if (el && el instanceof Element) {
    intersectionObserver.observe(el);
  }
};
const removeIntersectionObserver = el => {
  if (el && el instanceof Element) {
    intersectionObserver.unobserve(el);
  }
};
const disconnectIntersectionObserver = () => {
  intersectionObserver.disconnect();
};

setGlobal('svs.templates.productPageOnboarding.intersectionObserver', {
  addIntersectionObserver,
  removeIntersectionObserver,
  disconnectIntersectionObserver
});

 })(window);